import React from 'react'

// Recibimos data (la imagen/acción) y config (las posiciones y escala)
const SelfieFan = ({ data, config }) => {
    
    // Si no hay datos de imagen o la acción es hide, no renderizamos nada
    if (!data || !data.image || data.action === 'hide') return null;

    // Extraemos la configuración (con valores por defecto por seguridad)
    const { offsetX = 0, offsetY = 0, scale = 1 } = config || {};

    // Detectamos si es el QR u otra imagen
    const isQR = data.action === 'show_qr';

    return (
        <div 
            className='SelfieFan__Screen--Overlay' 
            style={{ 
                position: 'absolute',
                bottom: `${0 + offsetY}px`, 
                right: `${0 + offsetX}px`,
                transform: `scale(${scale})`,
                transformOrigin: 'bottom right',
                transition: 'all 0.2s ease-out'
            }}
        >
            {!data.type && (
                // <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" />
                <img src="/img/page/xolos-five.png" className="SelfieFan__Screen--Overlay__Logo" alt="Logo" style={{ width: '200px' }} />
            )}
            {data.type === 'selfie' && (
                <>
                    {/* <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" /> */}
                    <img src="/img/page/xolos-five.png" className="SelfieFan__Screen--Overlay__Logo" alt="Logo" style={{ width: '200px' }} />
                    <p className='mb-0 fs-5 text-center mt-2 text-white'>Envía tu foto</p>
                </>
            )}
            {data.type === 'message' && (
                <>
                    {/* <img src='/img/page/adsl-five.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" style={{ width: '150px' }} /> */}
                    <img src="/img/page/xolos-five.png" className="SelfieFan__Screen--Overlay__Logo" alt="Logo" style={{ width: '200px' }} />
                    <p className='mb-0 fs-5 text-center mt-2 text-white'>Envía tu mensaje</p>
                </>
            )}

            {/* Inyectamos el base64 dinámico o el QR */}
            <img
                src={data.image}
                //src='/img/overlays/selfiefan/qrselfiefan.png'
                className={`SelfieFan__Screen--Overlay__Image SelfieFan__Screen--Overlay__Image--Small`}
                alt={isQR ? "QR Code" : "Fan Cam"}
                style={isQR ? { objectFit: 'contain', backgroundColor: '#D9D9D9', padding: '5px' } : {}}
            />

            <p className='SelfieFan__Screen--Overlay__Credits'>Powered by Five Digital Minds</p>
        </div>
    );
};

export { SelfieFan };